import { render } from "./vh-moment.vue?vue&type=template&id=bb1f8998"
import script from "./vh-moment.vue?vue&type=script&lang=js"
export * from "./vh-moment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__